import React, { useState, useEffect } from 'react';
import { Button, Form, Input, Modal, Spin, Select ,message} from "antd";
import { postLifterPayment, getclientslist, getAllDoByClient } from '../../Services/Services';

const LifterPayFrm = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [lifteruserList, setlifteruserList] = useState([]);
    const [doList, setdoList] = useState([]);
    const [form] = Form.useForm();
    useEffect(() => {
        Getclientslist()
    }, [])
    const Getclientslist = async () => {
        const response = await getclientslist();
        if (response) {
            const filterLifter = response.lifter_user_list.filter(o =>o.com_name === localStorage.getItem('com_name'))
            setlifteruserList(filterLifter)
        }
    }
    const Get_Do_Details = async (id) => {
        // form.resetFields({'do_id'})
        const response = await getAllDoByClient({'com_name':localStorage.getItem('com_name'),'lifter_id':id})
        if (response) {
            setdoList(response);
        }
    };

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onFinish = async (values) => {
        setLoading(true);
        Object.assign(values,{'com_name':localStorage.getItem('com_name')})
        const response = await postLifterPayment(values);
        setLoading(false);
        if (response.msg='payment created') {
            message.success('Payment Creation Successful');
            setIsModalOpen(false);
            form.resetFields();

        } else {
            message.warning('Payment Creation Not Successful');
        }
    };

    return (
        <>
            <Modal
                visible={loading} // Correct prop name is visible, not open
                footer={null}
                closable={false}
                width={400}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img src='transduniyalogo.png' alt='img' width={200} style={{ margin: "10px" }} />
                    <Spin />
                    <h2>Lifter Payment Creating......</h2>
                </div>
            </Modal>

            <Button
                onClick={showModal}
                type='primary'
                ghost
                style={{
                    // float: "right",
                    margin: "10px",
                    backgroundColor: 'black',
                    color: 'white',
                    fontWeight: '600'
                }}
            >
                Add New Payment
            </Button>

            <Modal
                visible={isModalOpen} // Correct prop name is visible, not open
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
            >
                <Form
                  
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <div className=" grid grid-cols-1 sm:grid sm:grid-cols-2 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%] ">
                        <Form.Item
                            name="lifter_id"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Lifter Name!",
                                },
                            ]}
                            label={<b>Select Lifter Name</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                onChange={Get_Do_Details}
                            > {lifteruserList.map((e) => (
                                <Select.Option value={e.id}>
                                    {e.name}
                                </Select.Option>))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="do_id"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select DO Number!",
                                },
                            ]}
                            label={<b>Select DO No</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                            >
                                {doList.map((do_i) => (
                                    <Select.Option value={do_i.id}>
                                        {do_i.do_no}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Amount!",
                                },
                            ]}
                            name="pay_amount"
                            label={<b>Pay Amount</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input placeholder="Pay Amount" type="number" size="middle" />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Pay Date!",
                                },
                            ]}
                            name="date"
                            label={<b>Pay Date</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input type="date" size="middle" />
                        </Form.Item>

                    </div>
                    <Form.Item className="text-center" style={{ textAlign: 'center', marginRight: '40px' }}>
                        <Button
                            htmlType="submit"
                            style={{ color: "white", backgroundColor: 'black' }}
                        >
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default LifterPayFrm;
